import React, { useState, useEffect, useRef } from 'react'
import '../styles.less'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import MonitoringWidgets from '../../../widgets/projectProposal/monitoringAndInternalEvaluation/MonitoringWidgets'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { getMonitoring } from '../../../redux/actions/monitoring'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { useSelector } from 'react-redux'
import ViewPreviousVersionButon from '../../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import pathname from '../../../constants/pathname'
import ReportResultProjectWidget from '../../../widgets/projectProposal/monitoringAndInternalEvaluation/ReportResultProjectWidget'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'

export default function MonitoringAndInternalEvaluation() {
  const [schema, setSchema] = useState()
  const [schemaPrevious, setSchemaPrevious] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isViewPrevious, setIsViewPrevious] = useState(false)
  const [error, setError] = useState()
  const [showEditAll, setShowEditAll] = useState()
  const [isEditWidget, setIsEditWidget] = useState({})
  const [buttonRoutes, setButtonRoutes] = useState()

  const previousPanelRef = useRef(null)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (projectId) {
      handleGetSchema(projectId)
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  useEffect(() => {
    if (schema) {
      setButtonRoutePathname(schema?.formTemplate)
    }
  }, [schema])

  useEffect(() => {
    if (isViewPrevious && schemaPrevious) {
      previousPanelRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [isViewPrevious, schemaPrevious])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getMonitoring(proposalId)
      setSchema(_schema)
      setIsEditWidget({
        monitoring: _schema.forms?.monitoring?.id ? false : true,
        reportResultProject:
          _schema.forms?.monitoring?.reportResultProject?.tableView?.length > 0 ? false : true,
      })
      setShowEditAll(
        !_schema.forms?.monitoring?.disabled && !_schema.forms?.reportResultProject?.disabled
      )
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      const _schema = await getMonitoring(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.error(e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const setButtonRoutePathname = (formTemplate) => {
    if (formTemplate === 0 || typeof formTemplate == 'undefined') {
      setButtonRoutes({
        pathNameBackward: `${pathname.proposal.expectedResult}`,
        pathNameForward: `${pathname.proposal.projectManagementStructure}`,
      })
    } else {
      setButtonRoutes({
        pathNameBackward: `${pathname.proposal.expectedResult}`,
        pathNameForward: `${pathname.proposal.workingGroup}`,
      })
    }
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // 🚩 ก้อนที่ 1: จับข้อมูล "เวอร์ชันปัจจุบัน" มัดรวมไว้ในตัวแปรนี้ จะได้ไม่ต้องเขียนโค้ดซ้ำ 2 รอบ
  const renderCurrentVersion = (
    <div className="top">
      {schema?.forms?.monitoring && (
        <>
          <MonitoringWidgets
            showCommandButton={!schema.forms.monitoring.disabled}
            schema={schema?.forms?.monitoring}
            isEdit={isEditWidget.monitoring}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('monitoring', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}

      {/* วิธีรายงานผลลัพธ์ของโครงการ */}
      {schema?.forms?.monitoring?.reportResultProject && schema?.formTemplate != 0 && (
        <>
          <ReportResultProjectWidget
            showCommandButton={!schema.forms.monitoring.reportResultProject.disabled}
            schema={schema?.forms?.monitoring?.reportResultProject}
            isEdit={isEditWidget.reportResultProject}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('reportResultProject', _isEdit, setIsEditWidget)
            }
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ViewPreviousVersionButon 
        handleGetSchemaPrevious={handleGetSchemaPrevious} 
        isViewPrevious={isViewPrevious}
        masterSubjectId={'1-1028,1-1027,5-5012'}
      />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          routing={buttonRoutes}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          editWidget={isEditWidget}
          forms={schema?.forms}
        />
      )}

      <div className="wrapper">
        <div style={!isViewPrevious ? { width: '100%' } : {}}>
          {isViewPrevious ? (
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
            >
              {renderCurrentVersion}
            </Panel>
          ) : (
            renderCurrentVersion
          )}
        </div>

        {isViewPrevious && schemaPrevious && (
          <div ref={previousPanelRef}>
            <div className="line" />
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ก่อนหน้า'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed' }}
            >
              <div className="bottom">
                {schemaPrevious?.forms?.monitoring && (
                  <>
                    <MonitoringWidgets
                      showCommandButton={false}
                      schema={schemaPrevious?.forms?.monitoring}
                      isEdit={false}
                    />
                    <br />
                  </>
                )}

                {schemaPrevious?.forms?.monitoring?.reportResultProject &&
                  schemaPrevious?.formTemplate != 0 && (
                    <>
                      <ReportResultProjectWidget
                        showCommandButton={false}
                        schema={schemaPrevious?.forms?.monitoring?.reportResultProject}
                        isEdit={false}
                      />
                      <br />
                    </>
                  )}
              </div>
            </Panel>
            <br />
            <br />
          </div>
        )}
      </div>
    </SidebarProposal>
  )
}

// const _schema2 = {
//   header: 'การกำกับติดตาม และการประเมินติดตามภายใน (Monitoring)',
//   subHeader: 'ข้อเสนอโครงการ ',
//   projecCode: null,
//   projecName: null,
//   disabled: false,
//   formTemplate: 0,
//   forms: {
//     monitoring: {
//       id: null,
//       feedbackBySubject: null,
//       disabled: false,
//       header: 'การกำกับติดตาม และการประเมินติดตามภายใน',
//       buttonText: 'การกำกับติดตาม และการประเมินติดตามภายใน',
//       messageWarning:
//         'มีการระบุกลไกกำกับติดตาม และประเมินผลสัมฤทธิของโครงการ/ชุดโครงการที่ชัดเจน, ในระดับโครงการหรือชุดโครงการ อาจระบุกลไกและระยะเวลาในการติดตามความก้าวหน้า (เช่นรายไตรมาส) หรือใช้กลไกการติดตามที่กำหนดไว้ใน Gantt Chart (อาทิตามระยะเวลาการส่งมอบผลงาน)',
//       editorData: {
//         name: 'editorData',
//         label: null,
//         value: null,
//         validators: [
//           {
//             type: 'REQUIRED',
//             value: null,
//             errorMessage: 'กรุณากรอกการกำกับติดตาม และการประเมินติดตามภายใน (Monitoring)',
//           },
//           {
//             type: 'MAXLENGTH',
//             value: 1000,
//             errorMessage: 'กรอกวัตถุประสงค์ได้ไม่เกิน 255 ตัวอักษร',
//           },
//         ],
//       },
//       messageInfo:
//         'มีการระบุกลไกกำกับติดตาม และประเมินผลสัมฤทธิของโครงการ/ชุดโครงการที่ชัดเจน, ในระดับโครงการหรือชุดโครงการ อาจระบุกลไกและระยะเวลาในการติดตามความก้าวหน้า (เช่นรายไตรมาส) หรือใช้กลไกการติดตามที่กำหนดไว้ใน Gantt Chart (อาทิตามระยะเวลาการส่งมอบผลงาน)',
//       attachFiles: {
//         name: 'attachFiles',
//         description: ['แนบไฟล์อื่นที่เกี่ยวข้อง'],
//         value: [],
//         id: null,
//       },
//     },
//     reportResultProject: {
//       id: 1,
//       feedbackBySubject: null,
//       disabled: false,
//       header: 'วิธีรายงานผลลัพธ์ของโครงการ',
//       buttonText: 'วิธีรายงานผลลัพธ์ของโครงการ',
//       // resultOption: {
//       //   name: 'resultOption',
//       //   label: 'เลือกผลลัพธ์',
//       //   optionSelected: [],
//       //   options: [
//       //     {
//       //       label: 'ผลลัพธ์ทดสอบที่ 1',
//       //       value: '1',
//       //     },
//       //     {
//       //       label: 'ผลลัพธ์ทดสอบที่ 2',
//       //       value: '2',
//       //     },
//       //   ],
//       //   validators: [
//       //     {
//       //       type: 'REQUIRED',
//       //       value: null,
//       //       errorMessage: 'กรุณาเลือกผลลัพธ์',
//       //     },
//       //   ],
//       // },
//       resultIndicatorsOption: {
//         result: {
//           name: 'resultOption',
//           label: 'เลือกผลลัพธ์',
//           optionSelected: [],
//           options: [],
//           validators: [
//             {
//               type: 'REQUIRED',
//               value: null,
//               errorMessage: 'กรุณาเลือกผลลัพธ์',
//             },
//           ],
//         },
//         indicators: {
//           name: 'indicatorsOption',
//           label: 'เลือกตัวชี้วัด',
//           optionSelected: [],
//           options: [],
//           validators: [
//             {
//               type: 'REQUIRED',
//               value: null,
//               errorMessage: 'กรุณาเลือกตัวชี้วัด',
//             },
//           ],
//         },
//         valuesOption: [
//           {
//             label: 'ผลลัพธ์ทดสอบที่ 1',
//             value: '1',
//             indicators: [
//               {
//                 label: 'ตัวชี้วัดที่ 1',
//                 value: '1.1',
//               },
//               {
//                 label: 'ตัวชี้วัดที่ 2',
//                 value: '1.2',
//               },
//             ],
//           },
//           {
//             label: 'ผลลัพธ์ทดสอบที่ 2',
//             value: '2',
//             indicators: [
//               {
//                 label: 'ตัวชี้วัดที่ a',
//                 value: '2.1',
//               },
//               {
//                 label: 'ตัวชี้วัดที่ b',
//                 value: '2.2',
//               },
//             ],
//           },
//         ],
//       },
//       dataCollection: {
//         name: 'dataCollection',
//         label: 'ข้อมูลที่จะเก็บ',
//         value: null,
//         validators: [
//           {
//             type: 'REQUIRED',
//             value: null,
//             errorMessage: 'กรุณากรอกข้อมูลที่จะเก็บ',
//           },
//           {
//             type: 'MAXLENGTH',
//             value: 1000,
//             errorMessage: 'กรอกข้อมูลที่จะเก็บได้ไม่เกิน 255 ตัวอักษร',
//           },
//         ],
//       },
//       dataCollectionMethod: {
//         name: 'dataCollectionMethod',
//         label: 'วิธีเก็บข้อมูล',
//         value: null,
//         validators: [
//           {
//             type: 'REQUIRED',
//             value: null,
//             errorMessage: 'กรุณากรอกวิธีเก็บข้อมูล',
//           },
//           {
//             type: 'MAXLENGTH',
//             value: 1000,
//             errorMessage: 'กรอกวิธีเก็บข้อมูลได้ไม่เกิน 255 ตัวอักษร',
//           },
//         ],
//       },
//       tableView: [
//         {
//           result: '1. เกิดคณะทำงานที่มีในทักษะในการออกแบบกิจกรรมทางกายด้วยศิลปะวัฒนธรรมไทย',
//           indicators:
//             '1.1 เกิดคณะทำงาน จำนวน..5..คน ที่มีตัวแทนที่มีตัวแทน 2 ช่วงวัย <br /> 1.2 เกิดคณะทำงาน จำนวน..1..คน',
//           infoStored:
//             '1. รายชื่อ และบทบาทคณะทำงาน <br /> 2. แบบเก็บข้อมูลพฤติกรรมทำกิจกรรมทางกายภาพของคนในชุมชนทุกวัย',
//           storageMethod:
//             'ให้ระบุข้อมูลในตัวชี้วัด <br /> 1.1................. <br /> 1.2.................<br /> 1.3.................',
//         },
//       ],
//     },
//   },
// }
